import { ContainerModule } from 'inversify'
import TYPES from '../../config/inversify.types'
import { FloorPlanServiceImpl } from './floor-plan.service.impl'
import { FloorPlanStore } from '../../store/floor-plan'

export const FloorPlanModule = new ContainerModule((bind) => {
    bind(TYPES.FloorPlanService).to(FloorPlanServiceImpl).inSingletonScope()
    bind(TYPES.FloorPlanStore).to(FloorPlanStore).inSingletonScope()
})
